export const getFormParams = (form) => {
  const year = form.year.split('-')[1]
  return {...form, year}
}

export const getEventsFormattedData = (list) => {
  const orgList = Array.from(new Set(list.map(item => item.orgname))).filter(i => i)
  const data = {}
  list.forEach(item => {
    const {university_name, orgname, events, events_o, events_z} = item
    !data[university_name] && (data[university_name] = {})
    data[university_name][orgname] = events ? `${events_o} / ${events_z}` : ''
  })
  return {orgList, data}
}

export const getHEOFormattedData = (data) => {
  const result = {}
  data.forEach(item => {
    if (!item.university_name) {
      result['Всего по училищу'] ? result['Всего по училищу'].push(item) : result['Всего по училищу'] = [item]
    } else if (result[item.university_name]) {
      result[item.university_name].push(item)
    } else {
      result[item.university_name] = [item]
    }
  })
  return result
}